/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "qayna punchaw",
        "0": "kunan punchaw",
        "1": "paqarin",
        "future": {
          "other": "+{0} d"
        },
        "past": {
          "other": "-{0} d"
        }
      },
      "day-narrow": {
        "-1": "qayna punchaw",
        "0": "kunan punchaw",
        "1": "paqarin",
        "future": {
          "other": "+{0} d"
        },
        "past": {
          "other": "-{0} d"
        }
      },
      "day-short": {
        "-1": "qayna punchaw",
        "0": "kunan punchaw",
        "1": "paqarin",
        "future": {
          "other": "+{0} d"
        },
        "past": {
          "other": "-{0} d"
        }
      },
      "hour": {
        "0": "kay hora",
        "future": {
          "other": "+{0} h"
        },
        "past": {
          "other": "-{0} h"
        }
      },
      "hour-narrow": {
        "0": "kay hora",
        "future": {
          "other": "+{0} h"
        },
        "past": {
          "other": "-{0} h"
        }
      },
      "hour-short": {
        "0": "kay hora",
        "future": {
          "other": "+{0} h"
        },
        "past": {
          "other": "-{0} h"
        }
      },
      "minute": {
        "0": "kay minuto",
        "future": {
          "other": "+{0} min"
        },
        "past": {
          "other": "-{0} min"
        }
      },
      "minute-narrow": {
        "0": "kay minuto",
        "future": {
          "other": "+{0} min"
        },
        "past": {
          "other": "-{0} min"
        }
      },
      "minute-short": {
        "0": "kay minuto",
        "future": {
          "other": "+{0} min"
        },
        "past": {
          "other": "-{0} min"
        }
      },
      "month": {
        "-1": "qayna killa",
        "0": "kunan killa",
        "1": "hamuq killa",
        "future": {
          "other": "+{0} m"
        },
        "past": {
          "other": "-{0} m"
        }
      },
      "month-narrow": {
        "-1": "qayna killa",
        "0": "kunan killa",
        "1": "hamuq killa",
        "future": {
          "other": "+{0} m"
        },
        "past": {
          "other": "-{0} m"
        }
      },
      "month-short": {
        "-1": "qayna killa",
        "0": "kunan killa",
        "1": "hamuq killa",
        "future": {
          "other": "+{0} m"
        },
        "past": {
          "other": "-{0} m"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "qayna kimsa killa",
        "0": "kunan kimsa killa",
        "1": "hamuq kimsa killa",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "quarter-narrow": {
        "-1": "qayna kimsa killa",
        "0": "kunan kimsa killa",
        "1": "hamuq kimsa killa",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "quarter-short": {
        "-1": "qayna kimsa killa",
        "0": "kunan kimsa killa",
        "1": "hamuq kimsa killa",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "second": {
        "0": "now",
        "future": {
          "other": "+{0} s"
        },
        "past": {
          "other": "-{0} s"
        }
      },
      "second-narrow": {
        "0": "now",
        "future": {
          "other": "+{0} s"
        },
        "past": {
          "other": "-{0} s"
        }
      },
      "second-short": {
        "0": "now",
        "future": {
          "other": "+{0} s"
        },
        "past": {
          "other": "-{0} s"
        }
      },
      "week": {
        "-1": "qayna semana",
        "0": "kunan semana",
        "1": "hamuq semana",
        "future": {
          "other": "+{0} w"
        },
        "past": {
          "other": "-{0} w"
        }
      },
      "week-narrow": {
        "-1": "qayna semana",
        "0": "kunan semana",
        "1": "hamuq semana",
        "future": {
          "other": "+{0} w"
        },
        "past": {
          "other": "-{0} w"
        }
      },
      "week-short": {
        "-1": "qayna semana",
        "0": "kunan semana",
        "1": "hamuq semana",
        "future": {
          "other": "+{0} w"
        },
        "past": {
          "other": "-{0} w"
        }
      },
      "year": {
        "-1": "qayna wata",
        "0": "kunan wata",
        "1": "hamuq wata",
        "future": {
          "other": "+{0} y"
        },
        "past": {
          "other": "-{0} y"
        }
      },
      "year-narrow": {
        "-1": "qayna wata",
        "0": "kunan wata",
        "1": "hamuq wata",
        "future": {
          "other": "+{0} y"
        },
        "past": {
          "other": "-{0} y"
        }
      },
      "year-short": {
        "-1": "qayna wata",
        "0": "kunan wata",
        "1": "hamuq wata",
        "future": {
          "other": "+{0} y"
        },
        "past": {
          "other": "-{0} y"
        }
      }
    },
    "locale": "qu-BO"
  });
}